import React from 'react';
import { DataProvider, useDataContext } from './campaign-context';
import AppVocationOneCollege from '../AppVocationOneCollege';
import AppVocationJuniorCollege from '../AppVocationJuniorCollege';
import AppVocationStartCollege from '../AppVocationStartCollege';

// Clon de SwitchCampaignPage para /tuvocacion/c/:token?grades=... — mismos
// componentes College, datos desde la API interna de tuvocación.

const SwitchPage = props => {
  const { campaign, responses, isLoading } = useDataContext();
  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (!campaign && !isLoading) {
    return <div>Not found</div>;
  }

  if (campaign.SKU === 'VOCATION_ONE') {
    return <AppVocationOneCollege campaign={campaign} responses={responses} />;
  }

  if (campaign.SKU === 'VOCATION_JUNIOR') {
    return (
      <AppVocationJuniorCollege campaign={campaign} responses={responses} />
    );
  }

  if (campaign.SKU === 'VOCATION_START') {
    return (
      <AppVocationStartCollege campaign={campaign} responses={responses} />
    );
  }

  return (
    <div>
      <div>id</div>
    </div>
  );
};

const DataWrapper = props => {
  const query = new URLSearchParams(props.location.search);
  const gradeParam = query.get('grades');
  let grades = null;
  if (gradeParam) {
    grades = gradeParam.split(',');
  }
  return (
    <DataProvider token={props.match.params.token} grades={grades}>
      <SwitchPage {...props} />
    </DataProvider>
  );
};
export default DataWrapper;
